import React, {useState} from 'react';
import {Col, Row} from 'reactstrap';

import {ButtonSync} from "../../../components/buttons/buttonsActions";
import CurrencyList from "./_list";
import CurrencyForm from "./_form";
import {currencyService} from "../../../jwt/_services/promotions/currencyService";
import {showToastCustom} from "../../../components/toast/customToast";
import {error, success, updateMsg} from "../../../components/i18n/i18n";
import {showLoader} from "../../../components/loader/loader";


export default function Currency(props){
    const [collapseForm, setCollapseForm] = useState(false);
    const [item, setItem] = useState();
    const [loading, setLoading] = useState(false);

    const toggleForm = () => {
        setCollapseForm(!collapseForm);
        setItem(null);
    }

    const beginEdit = (data) => {
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    const syncFirebase = () => {
        setLoading(true);
        currencyService.syncFirebase()
            .then(_ => {
                setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    return (
        <div>
            {loading && showLoader()}
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !collapseForm ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonSync onClick={syncFirebase}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!collapseForm ? <CurrencyList beginEdit={beginEdit}/> : null}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {collapseForm ? <CurrencyForm toggleParent={toggleForm} item={item} app={props.app}/> : null}
                </Col>
            </Row>
        </div>
    );
}